export default [
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'fa-tachometer-alt',
    name: 'Dashboard',
    roleId: 1,
  },
  {
    title: 'Hashtag đơn hàng',
    group: 'apps',
    icon: 'fa-tag',
    name: 'hashtag-don-hang',
    roleId: 32,
    ignoreRoles: [2048]
  },
  {
    title: 'Voucher',
    group: 'voucher',
    icon: 'fa-tags',
    name: 'Voucher',
    roleId: 32,
    ignoreRoles: [2048],
    items: [
      {
        title: 'Quản lý voucher',
        component: 'VoucherList',
        roleId: 1
      },
      {
        title: 'Báo cáo voucher',
        component: 'VoucherReport',
        roleId: 1
      },
    ]
  },
  {
    title: 'Báo cáo',
    group: 'bao-cao',
    icon: 'fa-chart-line',
    name: 'Report',
    roleId: 4,
    items: [
      {
        title: 'Doanh thu',
        name: 'bao-cao-doanh-thu',
        component: 'bao-cao-doanh-thu',
        roleId: 8
      },
      {
        title: 'Lợi nhuận đặt hàng',
        name: 'thong-ke-loi-nhuan-dat-hang',
        component: 'thong-ke-loi-nhuan-dat-hang',
        roleId: 1,
      },
      // { 
      //   title: 'Phí mua hàng',
      //   name: 'thong-ke-phi-mua-hang',
      //   component: 'thong-ke-phi-mua-hang',
      //   roleId: 2,
      // },
      // {
      //   title: 'Phí vận chuyển',
      //   name: 'thong-ke-phi-van-chuyen',
      //   component: 'thong-ke-phi-van-chuyen',
      //   roleId: 4
      // },
      {
        title: 'Chênh lệch tỷ giá',
        name: 'thong-ke-tien-te',
        component: 'thong-ke-tien-te',
        roleId: 8,
      },
      {
        title: 'Thống kê nạp tiền',
        name: 'bao-cao-nap-tien',
        component: 'bao-cao-nap-tien',
        roleId: 8
      },
      {
        title: 'Thống kê hoa hồng',
        name: 'thong-ke-hoa-hong-nhan-vien',
        component: 'thong-ke-hoa-hong-nhan-vien',
        roleId: 8
      },
      {
        title: 'Vận hành kho',
        name: 'bao-cao-van-hanh-kho',
        component: 'bao-cao-van-hanh-kho',
        roleId: 8
      },
      {
        title: 'Nợ quá hạn - nợ xấu',
        name: 'bao-cao-no-xau',
        component: 'bao-cao-no-xau',
        roleId: 1
      },
    ]
  },
  {
    title: 'Mã HS',
    group: 'apps',
    icon: 'fa-code',
    name: 'HsCodeList',
    roleId: 1,
    badge: false
  },
  {
    title: 'Đơn hàng',
    group: 'apps',
    icon: 'fa-shopping-cart',
    name: 'OrderList',
    roleId: 32,
    badge: false,
    children: [
      { name: 'orderdetail', title: 'Chi tiết đơn hàng', component: 'OrderDetail' }
    ]
  },
  {
    title: 'Ký gửi',
    group: 'ky-gui',
    icon: 'fa-cart-plus',
    name: 'Deposit',
    roleId: 16,
    items: [
      {
        title: 'TMĐT',
        component: 'EcommerceList',
        roleId: 1
      },
      {
        title: 'Nhập khẩu',
        component: 'DepositList',
        roleId: 1,
        children: [
          { name: 'DepositDetail', title: 'Chi tiết đơn hàng', component: 'DepositDetail' }
        ]
      },
      {
        title: 'Xuất khẩu',
        component: 'DepositList2',
        roleId: 1,
        children: [
          { name: 'DepositDetail2', title: 'Chi tiết đơn hàng', component: 'DepositDetail2' }
        ]
      }
    ],
  },
  {
    title: 'Thanh toán hộ',
    group: 'thanh-toan-ho',
    icon: 'fa-credit-card',
    name: 'PayService',
    roleId: 64,
    items: [
      {
        title: 'Trực tiếp',
        component: 'PayServiceList',
        roleId: 1
      },
      {
        title: 'Ủy quyền',
        component: 'PayAuthorityList',
        roleId: 1
      }
    ]
  },
  {
    title: 'Kế toán',
    group: 'ke-toan',
    icon: 'fa-chart-line',
    name: 'Accountant',
    roleId: 128,
    items: [
      {
        title: 'Thanh toán',
        component: 'PayOrderList',
        roleId: 128
      },
      {
        title: 'Kiểm soát đơn hàng',
        component: 'AccountantOrder',
        roleId: 128
      },
      {
        title: 'Tài chính',
        name: 'bao-cao-tai-chinh',
        component: 'bao-cao-tai-chinh',
        roleId: 16,
      },
      {
        title: 'Công nợ',
        name: 'bao-cao-cong-no',
        component: 'bao-cao-cong-no',
        roleId: 128
      },
      // {
      //   title: 'Luồng thu chi (¥)',
      //   component: 'AccountantCumulationList',
      //   roleId: 1
      // },
      // {
      //   title: 'Luồng thu chi (₫)',
      //   component: 'AccountantCumulationVNDList',
      //   roleId: 1
      // },
      {
        title: 'Shop hoàn tiền KN',
        component: 'TuiKuanList',
        roleId: 1
      },
    ]
  },
  {
    title: 'Lead Manager',
    group: 'lead-manager',
    icon: 'fa-graduation-cap',
    name: 'LeadManager',
    roleId: 65536,
    items: [
      {
        title: 'Liên hệ',
        component: 'ContactList',
        roleId: 32
      },
      {
        title: 'Chăm sóc',
        component: 'ContactCareList',
        roleId: 32
      },
      {
        title: 'Cơ hội',
        component: 'OpportunityKaban',
        roleId: 32,
      },
      {
        title: 'Khách hàng',
        component: 'ContactCustomerList',
        roleId: 32
      },
      {
        title: 'Báo cáo',
        component: 'ContactReport',
        roleId: 32
      },
    ]
  },  
  {
    title: 'Tài chính nội bộ',
    group: 'apps',
    icon: 'fa-university',
    name: 'InternalFinanceList',
    roleId: 32768,
    children: [
      { name: 'InternalFinanceDetail', title: 'Chi tiết thu chi', component: 'InternalFinanceDetail'  }
    ]
  },
  {
    title: 'Tra cứu khách hàng',
    group: 'apps',
    icon: 'fa-user',
    name: 'CustomerList',
    roleId: 8,
    children: [
      { name: 'CustomerDetail', title: 'Chi tiết khách hàng', component: 'CustomerDetail'  }
    ]
  },
  {
    title: 'Tin SMS',
    group: 'apps',
    icon: 'fa-sms',
    name: 'BankMessages',
    roleId: 131072
  },
  {
    title: 'ZNS',
    group: 'zns',
    icon: 'fa-sms',
    name: 'ZnsMessages',
    roleId: 32,
    ignoreRoles: [2048],
    items: [
      {
        title: 'ZNS Quảng cáo',
        component: 'ZnsMsgList',
        roleId: 1
      },
      {
        title: 'ZNS thông báo',
        component: 'ZnsNotiList',
        roleId: 1
      }
    ]
  },
  {
    title: 'Nạp tiền',
    group: 'apps',
    icon: 'fa-wallet',
    name: 'RechargeNew',
    roleId: 16384
  },
  {
    title: 'Rút tiền',
    group: 'apps',
    icon: 'fa-wallet',
    name: 'WithdrawHistory',
    roleId: 16384   
  },
  {
    title: 'Khiếu nại',
    group: 'khieu-nai',
    icon: 'fa-exclamation-circle',
    name: 'ComplainGroup',
    roleId: 4096,
    items: [
      {
        title: 'Đơn hàng',
        component: 'Complain',
        roleId: 1
      },
      {
        title: 'Thanh toán hộ',
        component: 'PayAuthorityComplain',
        roleId: 2
      },
      {
        title: 'Kiện TMĐT',
        component: 'EcommerceComplain',
        roleId: 1
      }
    ]
  },
  {
    title: 'Mã vận đơn',
    group: 'quan-ly-ma-van-don',
    icon: 'fa-cubes',
    name: 'Transaction',
    roleId: 512,
    roles: [64],
    items: [
      {
        title: 'Mã vận đơn',
        component: 'Transaction',
        roles: [64],
        roleId: 1
      },
      {
        title: 'Khớp kiện',
        component: 'Tracing',
        roles: [64],
        roleId: 1
      }
    ]
  },
  {
    title: 'Kho gửi',
    group: 'kho-gui',
    icon: 'fa-store',
    name: 'StoreCN',
    roleId: 1,
    checkChildren: true,
    items: [
      {
        title: 'Nhập kho gửi',
        component: 'StoreManager',
        roleId: 1024
      },
      {
        title: 'Cảnh báo kiện',
        component: 'PackageWarning',
        roleId: 1024
      },
      {
        title: 'Bao hàng',
        component: 'BigPackage',
        roleId: 2048
      },
      {
        title: 'Thu chi kho gửi',
        component: 'StoreReportList',
        roleId: 8192
      }
    ]
  },
  {
    title: 'Đối soát bao hàng',
    group: 'apps',
    icon: 'fa-box',
    name: 'CheckBigpackage',
    roleId: 2048
  }, 
  {
    title: 'Trung chuyển',
    group: 'kho-trung-chuyen',
    icon: 'fa-store',
    name: 'TranferStoreGroup',
    roleId: 256,
    items: [
      {
        title: 'Bao hàng',
        component: 'TranferStoreManager',
        roleId: 1
      },
      {
        title: 'Kiện hàng',
        component: 'TranferStoreManagerPackage',
        roleId: 1
      }
    ]
  },
  {
    title: 'Kho nhận',
    group: 'kho-nhan',
    icon: 'fa-store',
    name: 'StoreVN',
    roleId: 256,
    items: [
      {
        title: 'Nhập kho',
        component: 'StoreManagerVN',
        roleId: 1
      },
      {
        title: 'Lưu kho',
        component: 'StoreVNKennel',
        roleId: 1
      },
      {
        title: 'Kiểm kho',
        component: 'StoreVNCheck',
        roleId: 1
      }
    ]
  },
  {
    title: 'Yêu cầu giao hàng',
    group: 'apps',
    icon: 'fa-shopping-bag',
    name: 'PaymentRequest',
    roleId: 262144
  },
  {
    title: 'Xuất kho nhận',
    group: 'xuat-kho',
    icon: 'fa-dolly-flatbed',
    roleId: 512,
    ignoreRoles: [2048],
    items: [
      {
        title: 'Phiếu xuất kho',
        component: 'ExportReceipt',
        roleId: 1
      },
      {
        title: 'Danh sách kiện xuất',
        component: 'Deliverable',
        badge: true,
        roleId: 1
      }
    ]
  },
  {
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'fa-cogs',
    name: 'Setting',
    roleId: 2,
    items: [
      {
        name: 'Configuration', 
        title: 'Cấu hình chung', 
        component: 'Configuration',
        roleId: 128
      },
      {
        name: 'ConfigPrice', 
        title: 'Bảng giá thanh toán hộ', 
        component: 'ConfigPrice',
        roleId: 64
      },
      {
        name: 'FlagList', 
        title: 'Hashtag', 
        component: 'FlagList', 
        children: [
          { name: 'FlagDetail', title: 'Chi tiết hashtag', component: 'FlagDetail' }
        ],
        roleId: 128
      },
      {
        name: 'SafeLevelList', 
        title: 'Cấp độ an toàn', 
        component: 'SafeLevelList', 
        children: [
          { name: 'SafeLevelDetail', title: 'Cấp độ an toàn', component: 'SafeLevelDetail' }
        ],
        roleId: 128
      },
      {
        title: 'Kho hàng gửi',
        name: 'ChinaStoreList',
        component: 'ChinaStoreList', 
        children: [
          { name: 'ChinaStoreDetail', title: 'Chi tiết kho gửi', component: 'ChinaStoreDetail' }
        ],
        roleId: 128
      },
      {
        title: 'Kho trung chuyển',
        name: 'TranferStoreList',
        component: 'TranferStoreList', 
        children: [
          { name: 'TranferStoreDetail', title: 'Chi tiết kho trung chuyển', component: 'TranferStoreDetail' }
        ],
        roleId: 128
      },
      {
        title: 'Kho hàng nhận',
        name: 'WarehouseList',
        component: 'WarehouseList', 
        children: [
          { name: 'WarehouseDetail', title: 'Chi tiết kho nhận', component: 'WarehouseDetail' }
        ],
        roleId: 128
      },
      {
        title: 'Nhân viên',
        name: 'StaffList',
        roleId: 1,
        component: 'StaffList', 
        children: [
          { name: 'StaffDetail', title: 'Chi tiết nhân viên', component: 'StaffDetail' }
        ],
        roleId: 128
      },
      {
        name: 'FeeBuyList', 
        title: 'Phí mua hàng', 
        component: 'FeeBuyList', 
        children: [
          { name: 'FeeBuyDetail', title: 'Chi tiết phí mua hàng', component: 'FeeBuyDetail' }
        ],
        roleId: 128
      },
      {
        name: 'PricesList', 
        title: 'Bảng giá vận chuyển', 
        component: 'PricesList', 
        children: [
          { name: 'PricesDetail', title: 'Chi tiết bảng giá', component: 'PricesDetail' }
        ],
        roleId: 128
      },
      // {
      //   name: 'FeeWeightList', 
      //   title: 'Phí cân nặng', 
      //   component: 'FeeWeightList', 
      //   children: [
      //     { name: 'FeeWeightDetail', title: 'Chi tiết phí cân nặng', component: 'FeeWeightDetail' }
      //   ]
      // },
      // {
      //   name: 'FeeVolumeList', 
      //   title: 'Phí khối', 
      //   component: 'FeeVolumeList', 
      //   children: [
      //     { name: 'FeeVolumeDetail', title: 'Chi tiết phí khối', component: 'FeeVolumeDetail' }
      //   ]
      // },
      {
        name: 'FeeCheckList', 
        title: 'Phí kiểm đếm', 
        component: 'FeeCheckList', 
        children: [
          { name: 'FeeCheckDetail', title: 'Chi tiết phí kiểm đếm', component: 'FeeCheckDetail' }
        ],
        roleId: 128
      },
      {
        name: 'FeeGuaranteeList', 
        title: 'Phí bảo hiểm', 
        component: 'FeeGuaranteeList', 
        children: [
          { name: 'FeeGuaranteeDetail', title: 'Chi tiết phí bảo hiểm', component: 'FeeGuaranteeDetail' }
        ],
        roleId: 128
      },
      {
        name: 'FeeReinforceList', 
        title: 'Phí gia cố', 
        component: 'FeeReinforceList', 
        children: [
          { name: 'FeeReinforceDetail', title: 'Chi tiết phí gia cố', component: 'FeeReinforceDetail' }
        ],
        roleId: 128
      },
      {
        name: 'FeeFoamList', 
        title: 'Phí bọt khí', 
        component: 'FeeFoamList', 
        children: [
          { name: 'FeeFoamDetail', title: 'Chi tiết phí bọt khí', component: 'FeeFoamDetail' }
        ],
        roleId: 128
      },
      {
        name: 'FeeWeightCommissionList', 
        title: 'CK hoa hồng', 
        component: 'FeeWeightCommissionList',
        roleId: 128
      },
      { 
        name: 'CustomerLevel', 
        title: 'Khách hàng thân thiết', 
        component: 'CustomerLevel',
        children: [
          { name: 'CustomerLevelDetail', title: 'Chi tiết level', component: 'CustomerLevelDetail' }
        ],
        roleId: 128
      }
    ]
  },
  // {
  //   title: 'Nhập liệu',
  //   group: 'apps',
  //   icon: 'input',
  //   name: 'DataManager',
  // },  
];
